module.exports = __webpack_public_path__ + "img/update-app-1.6faa7160.png";